const initialState = {
  invoice: {
    data: {},
  },
  payments: {
    submitting: false,
  },
  modals: {
    error: {
      open: false,
      title: '',
      message: '',
    },
  },
};

export default initialState;
